import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import {  Row, Col } from 'react-bootstrap';
import DeptLeft from '../People/Dept_Left'

const GallaryImages = [
    {
        images: [
            "https://files.iittp.ac.in/pics/creche/1.jpg",
            "https://files.iittp.ac.in/pics/creche/2.jpg",
            "https://files.iittp.ac.in/pics/creche/3.jpg",
            "https://files.iittp.ac.in/pics/creche/4.jpg",
            "https://files.iittp.ac.in/pics/creche/5.jpg",
            "https://files.iittp.ac.in/pics/creche/2023/6.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/7.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/8.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/9.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/10.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/11.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/12.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/13.jpeg",
            "https://files.iittp.ac.in/pics/creche/2023/14.jpeg"
        ]
    }
];




function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Creche" />
            <section className="team-area fix p-relative pt-120 pb-80" >
                 

                <div className="row">
                    <div className="col-lg-12 p-relative">
                        <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
               
                            <h3>Creche</h3>
                        </div>
                    </div>
                </div>

                <div className="container">


                    <Row>
                        <Col md={9} className='c-left custom-padding-color'>
                            <p>Our institute has a creche facility for children of the IIT Tirupati community. It is a common Institute facility which takes care of children of the age group of 6 months to 10 years of employees/students of IIT Tirupati. Guests at IIT Tirupati may also avail the facility at the Institute with prior intimation. At present, we have one caretaker and one housekeeping staff to help us run the facility. </p>
                            <p><i class="fas fa-map-marker-alt  me-1 text-orange font-weight-bold "></i> It is located on the ground floor of the <span className='fw-bold'>CRC building (TC12). </span> </p>
                            <p><i class="fas fa-envelope  me-1 text-orange font-weight-bold"></i> <Link className='c-link' to="creche@iittp.ac.in" target="_blank" >creche@iittp.ac.in</Link> </p>
                            <p><i class="fas fa-phone-alt me-1 text-orange font-weight-bold me-2"></i> <span className='fw-bold'>0877 250 3691 </span> (Any inquiries about the child, the parent may call the creche between 2:00 and 3:00 pm only) </p>
              
                            <h4 className='c-headline  mb-3 mt-4'>Facilities : </h4>
                            <p> It is currently furnished with a foldable mattress, colourful small chairs and a table, toys, a slide and a ball pool. A small kitchenette containing a fridge and a microwave oven has been organized. The restroom is conveniently located on the ground floor. The crèche facility is also equipped with a computer, telephone (intercom only) and CCTV.</p>

                            <h4 className='c-headline  mb-3 mt-4'>Days of Operation : </h4>
                            <p>Five days in a week i.e. from Monday to Friday. </p>
                            <p> <i class="far fa-clock fa-spin  mb-3 mt-4 me-1 text-orange font-weight-bold"></i> 9.00 a.m. - 5.30 p.m.</p>
                            <p><span className='text-orange'> Note:</span>  Crèche facility will not be available on Saturdays, Sundays and Institute holidays. </p>

                            <h4 className='c-headline mt-5 mb-3'>Information for the Parents:</h4>
                            <ul className='ms-3 c-lineheight2dot5 iarrow' >

                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Parents who wish to utilize daycare facility must fill out the registration form :
                                    <Link to="https://forms.gle/2VZCkBh7RADBZCSJA" target="_blank" rel="noopener noreferrer">
                                        <button>Click here to register</button>
                                    </Link>
                                 </li>

                                <li className='mt-3'><i className="fal fa-arrow-alt-circle-right me-3 c-link" />and submit the Creche fee deduction acceptance form :
                                
                                    <Link to="https://files.iittp.ac.in/pdfs/creche/2023/Creche%20Fee%20Deduction%20Acceptance%20form.pdf" target="_blank" rel="noopener noreferrer">
                                        <button> Click here to download </button>
                                    </Link>
                                </li>

                                <li className='mt-3'><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Please read the IIT Tirupati crèche rules before completing the form. Use one form for each child: 
                                    <Link to="https://files.iittp.ac.in/pdfs/creche/2023/Creche%20Rules%20August%202023-July%202024.pdf" target="_blank" rel="noopener noreferrer">
                                        <button> Click here to download </button>
                                    </Link>
                                </li>
                                
                            </ul>

                            <h4 className='c-headline mt-5 mb-3'>Members of the School & Creche Committee:</h4>
                            <div className='ms-5'>
                            
                                <p ><i class="fas fa-user me-2 text-orange font-weight-bold"></i> Dr. Prasanna V Sampath (Chair)</p>
                                <p ><i class="fas fa-user me-2 text-orange font-weight-bold"></i>Dr. Srijanani Anurag Prasad (Member Secretary)</p>
                                <p ><i class="fas fa-user me-2 text-orange font-weight-bold"></i> Dr M. Nabil (Member)</p>
                                <p ><i class="fas fa-user me-2 text-orange font-weight-bold"></i>Dr. Yujendra Mitikiri (Member)</p>
                                <p ><i class="fas fa-user me-2 text-orange font-weight-bold"></i>  Mr. Chaman Mehta (Member)</p>
                                <p ><i class="fas fa-user me-2 text-orange font-weight-bold"></i> Mr Kishore Kumar (Member)</p>
                                <p ><i class="fas fa-user me-2 text-orange font-weight-bold"></i> Mr Rajan Babu (Treasurer, Ex-officio)</p>
                                
                            </div>
                        </Col>
                        <Col md={3} className='c-right'>

                            {/*--------------------------- Gallary */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline  mb-5'>Gallery</h3>
                                {GallaryImages.map((gallery, index) => (
                                    <div key={index} className="col-xl-12">
                                        <div className="row">
                                            {gallery.images.map((image, imgIndex) => (
                                                <div key={imgIndex} className="col-xl-6 col-md-4 mb-6">
                                                    <img src={image} alt={`img-${imgIndex}`} style={{ width: '100%', height:'75%' }} />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>


                          
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main